import request from '@/common/request'

class AtualizacaoService {
  getAll() {
    return request.get('/atualizacoes')
  }

  getByEmpresa(empresaId) {
    return request.get(`/atualizacoes/empresas/${empresaId}`)
  }

  getById(id) {
    return request.get(`/atualizacoes/${id}`)
  }

  getLogByAtualizacao(id) {
    return request.get(`/atualizacoes/${id}/logs`)
  }

  create(data) {
    return request.post('/atualizacoes', data)
  }

  update(id, data) {
    return request.patch(`/atualizacoes/${id}`, data)
  }

  vinculateXmlToRegisters(atualizacaoId) {
    return request.put(`/atualizacoes/${atualizacaoId}/vincula/notas-fiscais`)
  }

  vinculateRulesToRegisters(atualizacaoId) {
    return request.put(`/atualizacoes/${atualizacaoId}/vincula/regras`)
  }

  copiarConferencia(atualizacaoIdOrigem, atualizacaoIdDestino) {
    return request.patch(`/atualizacoes/copia/${atualizacaoIdOrigem}/${atualizacaoIdDestino}`)
  }

  marcarVerdesPelaEntrada(atualizacaoId) {
    return request.patch(`/atualizacoes/${atualizacaoId}/marcar-verdes`)
  }
}

export default new AtualizacaoService()
